import EventPost from 'flarum/forum/components/EventPost';
import punctuateSeries from 'flarum/common/helpers/punctuateSeries';
export default class DiscussionMergePost extends EventPost {
  static initAttrs(attrs) {
    super.initAttrs(attrs);
    const content = attrs.post.content();

    // Extract count and titles from the post content
    attrs.mergeCount = content?.count || 0;
    attrs.mergeTitles = Array.isArray(content?.titles) ? punctuateSeries(content.titles).join('') : '';
  }

  /**
   * Get the name of the event icon.
   */
  icon() {
    return 'fas fa-code-branch fa-flip-vertical';
  }

  /**
   * Get the translation key for the description of the event.
   */
  descriptionKey() {
    return 'fof-merge-discussions.forum.post.merged';
  }

  /**
   * Get the translation data for the description of the event.
   */
  descriptionData() {
    const data = {
      count: m("strong", null, this.attrs.mergeCount),
      titles: m("em", null, this.attrs.mergeTitles)
    };
    return data;
  }
}
flarum.reg.add('fof-merge-discussions', 'forum/components/DiscussionMergePost', DiscussionMergePost);